var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',[_c('h1',[_vm._v("This is an about page")]),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda cumque possimus sequi rerum quisquam ipsam alias. Illum laborum molestias possimus corporis delectus laudantium unde ipsum deserunt dolore. Atque, cumque nam.")])])
}]

export { render, staticRenderFns }